export const STATUS = {
    ADD: "ADD",
    READ: "READ",
    DEL: "DEL",
    DELW: "DELW",
    CLOS: "CLOS",
    ADDW: "ADDW",
    UP: "UP",
    OK: "OK",
    UPW: "UPW",
}

export const CONSTANT = {
    common: {
        id: 0,
        compositeId: {},
        etat: STATUS.OK,
        miseajour: 0,
        editable: true,
        editeur: 0,
        tag: null,
        metadata: "{}",
        libelle: ''
    },
};


export const FILTERS_STRING = [
    { key: "common.etat", operator: "EQUAL", field_type: "STRING", value: "OK" },
    /*{ key: "common.etat", operator: "EQUAL", field_type: "STRING", value: "ADDW" },*/
]
